import { render, staticRenderFns } from "./InventoryList.vue?vue&type=template&id=2e0b43a2&scoped=true"
import script from "./InventoryList.vue?vue&type=script&lang=js"
export * from "./InventoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0b43a2",
  null
  
)

export default component.exports